import { createFileRoute, redirect } from "@tanstack/react-router";

// Calendar page retired — send admins to the dashboard.
export const Route = createFileRoute("/admin/calendar")({
  beforeLoad: () => {
    throw redirect({ to: "/admin" });
  },
});
